<template>
  <el-dialog :title="!!info.staffId ? '编辑账号' : '新增账号'"
             :visible.sync="visible"
             width="560px"
             append-to-body
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             @closed="handleClose">
    <el-form ref="ruleForm"
             :model="info"
             :rules="rules"
             label-width="120px">
      <el-form-item label="员工账号："
                    prop="account">
        <el-input v-model="info.account"
                  :disabled="!!info.staffId"></el-input>
      </el-form-item>
      <el-form-item label="员工/合作商："
                    prop="staffName">
        <el-input v-model="info.staffName"></el-input>
      </el-form-item>
      <el-form-item label="员工手机号："
                    prop="mobile">
        <el-input v-model="info.mobile"></el-input>
      </el-form-item>
      <el-form-item label="功能权限："
                    prop="functions">
        <checkbox-tree :treeData="menuNodes"
                       nodeKey="funcId"
                       :defaultProps="defaultProps"
                       v-model="info.functions" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button :loading="loading"
                 @click="visible = false">取 消</el-button>
      <el-button type="primary"
                 :loading="loading"
                 @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import CheckboxTree from '@/components/public/checkbox-tree.vue'
import { guid } from '@/utils/index'
export default {
  name: 'edit-staff-modal',
  components: { CheckboxTree },
  props: {
    callback: { type: Function }
  },
  data () {
    return {
      loading: false,
      visible: false,
      menuNodes: [],
      defaultProps: { children: 'children', label: 'menuName' },
      info: { staffId: null, account: '', staffName: '', mobile: '', functions: [] },
      rules: {
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ],
        staffName: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ],
        functions: [
          { required: true, message: '功能权限不能为空', trigger: 'change' }
        ],
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    handleClose () {
      this.menuNodes = []
      this.info = { ...this.info, ...this.$options.data().info }
    },
    handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { staffId, functions } = this.info
          const dispatch = staffId ? 'updatestaff' : 'addstaff'
          const functionList = functions.filter(item => typeof item === 'number').map(item => ({ funcId: item }))
          this.$store.dispatch(`staff/${dispatch}`, {
            payload: { ...this.info, userType: 202, password: '123456', functions: functionList },
            success: () => {
              this.loading = false
              this.visible = false
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getportalmenutree2orgtype () {
      this.loading = true
      this.$store.dispatch('staff/getorgportalmenutree', {
        payload: { orgType: 202 },
        success: res => {
          this.loading = false
          res.data.menuNodes.forEach(item => {
            if (!item.funcId) {
              item.funcId = `custom-${guid()}`
            }
            item.children = item.children || []
          })
          this.menuNodes = res.data.menuNodes
        },
        fail: () => {
          this.loading = false
          this.menuNodes = []
        }
      })
    },
    init (options = {}) {
      this.info = { ...this.info, ...options }
      this.getportalmenutree2orgtype()
      this.visible = true
    }
  }
}
</script>
